import { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { onDemandSidebarItems } from "../constents";
import AppVersionBadge from "./AppVersionBadge";
import LanguageSwitcher from "./LanguageSwitcher";

const OnDemandSideBar = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (link) => {
    setOpen(false);
    if (location.pathname === link) return;
    navigate(link);
  };

  return (
    <>
      <button
        type="button"
        className="sidebar-hamburger xl:hidden fixed top-4 left-4 z-[60] bg-third p-2 rounded-lg shadow-lg"
        onClick={() => setOpen(true)}
        aria-label={t("common.openSidebar")}
      >
        <svg
          width="32"
          height="32"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
      {open ? (
        <div
          className="fixed inset-0 bg-black/40 z-[55] xl:hidden"
          onClick={() => setOpen(false)}
          aria-hidden
        />
      ) : null}
      <aside
        className={`
          sidebar-aside
          fixed top-0 left-0 z-[60] h-dvh w-60 shrink-0
          bg-third xl:bg-transparent p-5 pl-0 pt-8
          flex flex-col gap-8 overflow-y-auto overflow-x-hidden
          transition-transform duration-300 pointer-events-auto
          ${open ? "translate-x-0" : "-translate-x-full"}
          xl:sticky xl:top-0 xl:translate-x-0 xl:h-screen xl:self-start
        `}
      >
        <div className="xl:hidden flex justify-end mb-4 pr-3 rtl:justify-start">
          <button
            type="button"
            onClick={() => setOpen(false)}
            aria-label={t("common.closeSidebar")}
          >
            <svg
              width="28"
              height="28"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="logo pl-3 pr-3 shrink-0 flex flex-col gap-4 min-w-0">
          <img src="/img/eco-logo2.svg" alt="ecoTransferz" className="max-w-full" />
          <div className="hidden xl:block w-full min-w-0 max-w-full">
            <LanguageSwitcher variant="sidebar" />
          </div>
        </div>

        <ul className="flex flex-col gap-3 p-0 flex-1 min-w-0">
          {onDemandSidebarItems.map((el) => (
            <li key={el.link} className="w-full">
              <NavLink
                to={el.link}
                end={el.link === "/on-demand"}
                onClick={(e) => {
                  e.preventDefault();
                  goTo(el.link);
                }}
                className={({ isActive }) =>
                  isActive
                    ? "sidebar-nav-link sidebar-nav-link-active w-full flex items-center pl-8 gap-2 [background:var(--gradient-primary)] rounded-br-full rounded-tr-full py-5 text-third font-bold"
                    : "sidebar-nav-link w-full text-black font-bold flex items-center pl-8 gap-2 py-5"
                }
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? el.activeIcon : el.icon}
                      alt=""
                      className="shrink-0"
                    />
                    <span className="truncate">{t(el.titleKey)}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="pl-3 pr-3 pb-4 mt-auto flex flex-col gap-3 shrink-0">
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              navigate("/dashboard");
            }}
            className="w-full h-12 rounded-full bg-secondary text-white font-bold flex items-center justify-center gap-2 cursor-pointer hover:opacity-90 transition shadow-sm"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18l-6-6 6-6"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {t("common.mainAdmin")}
          </button>
          <AppVersionBadge />
        </div>
      </aside>
    </>
  );
};

export default OnDemandSideBar;
